import { useState, useEffect } from "react";
import '../App.css';
import '../common/common.css';
import './ContentView.css';
import InfoArea from "./InfoArea";
import Image from "./Image";
import ImageCarousel from "./ImageCarousel";
import ImageOverlay from "./ImageOverlay";
import ExitButton from "../common/ExitButton";

// ContentView component to show location details (or default data in desktop mode)

function ContentView({ showContent, setIsMarkerSelected, content, placeholderData, isCollapsed }) {

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [overlayImageIndex, setOverlayImageIndex] = useState(0);

    // Resetting the image index from the image carousel whenever the content changes (e.g., another
    // marker is clicked)
    useEffect(() => {
        setCurrentImageIndex(0);
    }, [content])

    return(
        <div className={`ContentView ${isCollapsed ? 'collapsed' : ''}`}>

            {/* If a marker is clicked, display location details */}
            {showContent ? 
                <div>
                    {/* Exit Button */}
                    <ExitButton
                        onClick={() => setIsMarkerSelected(false)}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    />

                    {/* Location name */}
                    <h2 className="ContentViewName">{content.name}</h2>

                    {/* Image carousel */}
                    {content.images?.length > 0 && (
                        <ImageCarousel
                            images={content.images}
                            onImageClick={(index) => {
                                setOverlayImageIndex(index);
                                setIsOverlayOpen(true);
                            }}
                        />
                    )}

                    {/* Clicking an image will display it in an overlay */}
                    {isOverlayOpen && content.images?.length > 0 && (
                        <ImageOverlay
                            overlayImageIndex={overlayImageIndex}
                            setOverlayImageIndex={setOverlayImageIndex}
                            content={content}
                            setIsOverlayOpen={setIsOverlayOpen}
                        />
                    )}

                    {/* Check for locationInfo fields and display them */}
                    {content.locationInfos && content.locationInfos
                        .slice()
                        .sort((a, b) => a.info_type.order - b.info_type.order)
                        .map((info) => (
                            <InfoArea
                                key={info.id}
                                title={info.info_type.title}
                                value={info.content}
                                icon={info.info_type.icon}
                            />
                    ))}

                </div>
                : 
                // If no marker is selected, display placeholder content
                <div className="DefaultContent">
                    <h2  className="ContentViewName" style={{ marginTop: "30px" }}>{placeholderData.title}</h2>
                    {placeholderData.img?.image?.url && (
                        <div className="DefaultImgWrapper">
                            <Image
                                className="DefaultImg"
                                img={placeholderData.img}
                                alt="DefaultImg"
                                onClick={() => {
                                    setOverlayImageIndex(currentImageIndex);
                                    setIsOverlayOpen(true);
                                }}
                            />
                        </div>
                    )}
                    <InfoArea
                        title="Hintergrund"
                        value={placeholderData.description}
                    />

                    {/* Logos */}
                    <div>
                        {placeholderData.logos && placeholderData.logos.map((logo) => (
                            <img
                                className="Logos"
                                alt="logo"
                                key={logo.id}
                                src={`${process.env.REACT_APP_API_BASE_URL}${logo.url}`}
                            />
                        ))}
                    </div>
                </div>
            }
        </div>
    )

}

export default ContentView;